{
	"orders": {
		"activeOrders": {
			"filled": "Исполненные",
			"open": "Открытые",
			"canceled": "Отмененные"
		}
	}
}
